import * as splashPageService from '/source/js/services/splashPageService';

let $splashPage;
let aboBaseUrl;
let market;
let orderSubType;
let isFtOn;

$('.redirectsponsorshipflow').on('click', function () {
    if(isFtOn) {
        redirectToGatewayPage();
    } else {
        var aboUrl = aboBaseUrl + '/Sitecore/Common/Start?flowType=internationalsponsorship';
        window.location.href = aboUrl;
    }
});

async function redirectToGatewayPage() {
    let request = {
        'Market': market,
        'OrderFlow': 'Onetime',
        'OrderSubType': orderSubType,
        'Action': 'InternationalSponsorship',
        'RedirectUrl': null,
        'ShouldCheckForInProgress': false,
        'IsNfr': false
    };

    try {
        $('#splash-page-redirect-sponsorshipflow').prop('disabled', true);
        const result = await splashPageService.redirectToGateway(request);
        if(result) {
            window.location = result;
        }
    } catch (ex) {
        $('#splash-page-redirect-sponsorshipflow').prop('disabled', false);
        console.log(ex);
    }
}

$(function () {
    $splashPage = $('.splashPageInfo');
    if($splashPage.length < 1) return;

    market = $splashPage.data('is-market');
    orderSubType = $splashPage.data('is-ordersubtype');
    isFtOn = $splashPage.data('is-isfton').length > 0 && $splashPage.data('is-isfton').toLowerCase() === 'true';
    aboBaseUrl = $splashPage.data('is-abobaseurl');
});
